import * as angular from 'angular';
import * as _ from 'lodash';

import { TagDateValue } from '../../models/index';
import { ChartIdentifierWidgetConfiguration } from './chartByIdentifier.configuration';

export function mapSeries(
    series: any[],
    data: TagDateValue[],
    item: { map?: any; configuration: ChartIdentifierWidgetConfiguration },
    options: { dataFormat: any }
): any[] {
    const { map, configuration } = item;
    let results = [];
    if (series && options && options.dataFormat) {
        results = series.map(s => {
            s = angular.copy(s);
            let guid = s.guid;
            if (!s.selector) {
                s.selector = d => d.valueType + d.guid;
            }
            if (map) {
                for (const key of Object.keys(map)) {
                    if (map[key] === guid) {
                        guid = key;
                        break;
                    }
                }
            }
            const found: any = _.find(configuration.series, sc => sc.guid === guid && s.valueType === sc.value);
            s.color = found && configuration.options.coloringMode === 1
                ? found.color
                : configuration.options.color;
            if (!s.replaced) {
                const format = s.format;
                s.format = (d: TagDateValue) => {
                    return s.unitName
                        ? `${format(d)} [${s.unitName}]`
                        : `${format(d)}`;
                };
                s.replaced = true;
            }
            return s;
        });
        let sort = (a, b) => a.sortOrder < b.sortOrder ? -1 : 1;
        if (data && data.length) {
            switch (configuration.options.orderBy) {
                case 1:
                    //largest to smallest
                    sort = (a, b) => {
                        const valueA = _.find(data,
                            (d: TagDateValue) => options.dataFormat.identifier(d)
                                === options.dataFormat.identifier(a));
                        const valueB = _.find(data,
                            (d: TagDateValue) => options.dataFormat.identifier(d)
                                === options.dataFormat.identifier(b));
                        let vA;
                        if (valueA) {
                            vA = valueA.value;
                        }
                        let vB;
                        if (valueB) {
                            vB = valueB.value;
                        }
                        return vA > vB ? -1 : 1;
                    };
                    break;
                case 2:
                    sort = (a, b) => {
                        const valueA = _.find(data,
                            (d: TagDateValue) => options.dataFormat.identifier(d)
                                === options.dataFormat.identifier(a));
                        const valueB = _.find(data,
                            (d: TagDateValue) => options.dataFormat.identifier(d)
                                === options.dataFormat.identifier(b));
                        let vA;
                        if (valueA) {
                            vA = valueA.value;
                        }
                        let vB;
                        if (valueB) {
                            vB = valueB.value;
                        }
                        return vA < vB ? -1 : 1;
                    };
                    break;
                case 0:
                case null:
                case undefined:
                default:
                    break;
            }
        }
        results = results.sort(sort);
    }
    return results;
}